<template>
    <div class="time-picker">
        <div class="time-picker-title">
            Time
        </div>

        <div class="time-picker-container">
            <div ref="options" class="time-picker-options">
                <button
                    v-for="(label, key) in options"
                    :key="key"
                    :disabled="disabled"
                    :class="['time-picker-option', { active: key === value }]"
                    :data-time="key"
                    @click.prevent="$emit('change', key)"
                >
                    {{ label }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { chain } from 'lodash';

export default {
    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        value: {
            type: String,
            default: null,
        },
        options: {
            required: true,
            type: Object,
        },
        defaultTime: {
            type: String,
            default: null,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
    },

    /**
     * Scrolls options list to current value after mounting other components.
     */
    mounted() {
        this.$nextTick(() => {
            this.scroll();
        });
    },

    methods: {
        /**
         * Scrolls options list to current value.
         */
        scroll() {
            if (! this.value && ! this.defaultTime) {
                return;
            }

            const index = this.getTimeOptionIndex();
            const options = this.$refs.options;
            const option = options.children[index];

            if (option) {
                const offset = option.getBoundingClientRect().top - options.getBoundingClientRect().top;

                options.scrollTo(0, offset);
            }
        },

        /**
         * Returns index of suggested time in options list.
         *
         * @returns {number} Index of suggested time in options list.
         */
        getTimeOptionIndex() {
            const index = chain(this.options)
                .keys()
                .indexOf(this.value || this.defaultTime)
                .value();

            return 0 < index ? index : 0;
        },
    },
};
</script>
